<footer class="footer">
    <div class="container">
        <div class="d-flex flex-column flex-md-row">

            <div class="col-md-6 col-12 mb-4 mb-md-0">
                <div class="d-flex flex-column flex-md-row mb-md-4 privacyPolicy">
                    <div class="mb-4 mb-md-0 me-md-5 footer-item">
                        <a href="https://www.manyataformothers.org/privacy-policy/" target="blank" class="footer-link">
                            Privacy Policy
                        </a>
                    </div>


                    <div class="footer-item">
                        <a href="https://www.manyataformothers.org/refund-cancellation/" target="blank" class="footer-link">
                            REFUND & CANCELLATION
                        </a>
                    </div>
                </div>

                <div class="d-none d-md-block">
                    {{copyrightText}}
                </div>
            </div>

            <div class="col-md-6 col-12 ps-md-5">
                <div class="connectUs">
                    <div>CONNECT WITH US!</div>
                </div>

                <div class="social-menu d-flex ">
                    <span *ngFor="let item of images">
                        <a [href]="item?.link" target="blank" class="me-3 anchor">
                            <i [class]="item?.class"></i>
                        </a>
                    </span>
                </div>
            </div>

            <div class="d-block d-md-none mt-4 copyright-text">
                {{copyrightText}}
            </div>

        </div>
    </div>
    <div class=" scrollUp" (click)="scrollToTop()">
        <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </div>
</footer>